import WelcomeMessage from './WelcomeMessage/WelcomeMessage'
import useHome from './useHome'
import SpeedFormation from './SpeedFormation/SpeedFormation'
import { Gamification } from './Gamification'
import { HalfCard, Card, FlexContainer, Header1 } from '@/shared/theme/styled-components'

const Home = () => {
  const { data, isLoading, isExternal, country, t } = useHome()

  if (isLoading || !data) {
    return (
      <Card>
        <p>{t('common:fetching_data')}</p>
      </Card>
    )
  }

  return (
    <>
      <FlexContainer id='home-welcome'>
        <HalfCard>
          <Header1>{t('home:home_welcome')}</Header1>
          <WelcomeMessage />
        </HalfCard>
        {!isExternal && country !== 'de' && (
          <HalfCard>
            <Header1>{t('home:speed_formation.title')}</Header1>
            <SpeedFormation />
          </HalfCard>
        )}
      </FlexContainer>
      <Gamification country={country} />
    </>
  )
}

export default Home
